import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { SCCheckbox } from 'rollup-allspark';
import ComponentPlaceholder from '../../../../components/ComponentPlaceholder';
import { isEmpty } from '../../../../utils';
import { updateEntity } from '../../actions';
import { makeSelectProperty } from '../../selector';

const CategoryList = ({
  categories = [],
  checkedCategories = [],
  checkedItems = [],
  selectedFilterMenu = null,
  updateField,
}) => {
  const [filteredCategories, setFilteredCategories] = useState([]);

  useEffect(() => {
    setFilteredCategories(categories);
  }, [categories]);

  useEffect(() => {
    if (!isEmpty(selectedFilterMenu)) {
      const filtered = categories.filter(c =>
        c.linkedSections.some(
          ls => ls.sectionID === selectedFilterMenu.sectionID,
        ),
      );
      setFilteredCategories(filtered);
    } else {
      setFilteredCategories(categories);
    }
  }, [selectedFilterMenu]);

  const onCategorySelected = (cat, val) => {
    const filedsToUpdate = {};

    if (val) {
      filedsToUpdate.checkedCategories = [...checkedCategories, cat.id];
      filedsToUpdate.checkedItems = [
        ...new Set([
          ...checkedItems,
          ...(cat.linkedItems?.map(li => li.id) || []),
        ]),
      ];
    } else {
      filedsToUpdate.checkedCategories = checkedCategories.filter(
        id => id !== cat.id,
      );
      filedsToUpdate.checkedItems = checkedItems.filter(
        id => !cat.linkedItems?.map(li => li.id).includes(id),
      );
    }

    updateField(filedsToUpdate);
  };

  if (isEmpty(filteredCategories)) {
    return (
      <div className="w-full flex flex-col items-center justify-center">
        <ComponentPlaceholder label="No categories found" />
      </div>
    );
  }

  const headerEl = (
    <div className="flex items-center bg-grey-lighter py-3 px-4 font-medium rounded-tl-lg">
      Categories
    </div>
  );

  const listEl = filteredCategories.map(c => (
    <div
      className="flex items-center px-4"
      key={c.id}
      role="presentation"
      onClick={() => onCategorySelected(c, !checkedCategories.includes(c.id))}
    >
      <SCCheckbox
        value={checkedCategories.includes(c.id)}
        handleChange={v => onCategorySelected(c, v)}
      />
      <div className="flex flex-1 items-center h-11 cursor-pointer">
        {c.id}. {c.title.en}
      </div>
    </div>
  ));

  return (
    <div className="flex flex-col divide-y divide-grey w-full rounded-lg border border-grey">
      {headerEl}
      {listEl}
    </div>
  );
};

CategoryList.propTypes = {
  categories: PropTypes.array,
  checkedCategories: PropTypes.array,
  checkedItems: PropTypes.array,
  selectedFilterMenu: PropTypes.object,
  updateField: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  categories: makeSelectProperty('categories'),
  checkedCategories: makeSelectProperty('checkedCategories'),
  checkedItems: makeSelectProperty('checkedItems'),
  selectedFilterMenu: makeSelectProperty('selectedFilterMenu'),
});

const mapDispatchToProps = dispatch => ({
  updateField: payload => dispatch(updateEntity(payload)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(CategoryList);
